/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-array-constructor */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import StaticDateRangePicker from "@mui/lab/StaticDateRangePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
  rangePickerDisabledDate,
  getCustomizedDate,
} from "../../../redux/constants";

import {
  setDateValue,
  setTimeValue,
  setRelativeCount,
} from "../../../redux/actions/DateTime";
import { getPaneIndex } from "../../../redux/constants";
import isEqual from "react-fast-compare";

const Absolute = ({ type, datePicker, timeFlag, split, setKeepAsRelative }) => {
  const dispatch = useDispatch();
  const timeValue = useSelector((state) => state.DateTime.timeValue);
  const dateValue = useSelector((state) => state.DateTime.dateValue);

  const [localDate, setlocalDate] = useState(null);
  const [localTime, setlocalTime] = useState(null);
  const [campaignDate, setCampaignDate] = useState(null);

  let dateObj = getCustomizedDate(6, "Days");
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const screen = useSelector((state) => state?.Screens?.screen);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);
  let graphDetailDuration = graphDetail?.duration;
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );

  useEffect(() => {
    if (panes[index]?.quick_filter === "CampaignID" && !authParams?.screen_id) {
      let start_date = moment(panes[index]?.campaign_date?.from);
      let end_date = moment(panes[index]?.campaign_date?.to);
      let dateDiff = end_date?.diff(start_date, "days") + 1;

      let finalStartDate =
        panes &&
        index >= 0 &&
        moment(panes[index]?.campaign_date?.from)?.format("D MMM YYYY");
      let finalEndDate =
        dateDiff > 30
          ? moment(start_date)?.add(30, "d")?.format("D MMM YYYY")
          : moment(panes[index]?.campaign_date?.to)?.format("D MMM YYYY");

      let defaultCampaignDate = [finalStartDate, finalEndDate];
      setCampaignDate(defaultCampaignDate);
    }
  }, [panes]);

  // for screen
  useEffect(() => {
    if (screen?.quick_filter === "CampaignID" && authParams?.screen_id) {
      let start_date = moment(screen?.campaign_date?.from);
      let end_date = moment(screen?.campaign_date?.to);
      let dateDiff = end_date?.diff(start_date, "days") + 1;

      let finalStartDate =
        screen && moment(screen?.campaign_date?.from)?.format("D MMM YYYY");
      let finalEndDate =
        dateDiff > 30
          ? moment(start_date)?.add(30, "d")?.format("D MMM YYYY")
          : moment(screen?.campaign_date?.to)?.format("D MMM YYYY");

      let defaultCampaignDate = [finalStartDate, finalEndDate];
      setCampaignDate(defaultCampaignDate);
    }
  }, [screen]);

  useEffect(() => {
    //useeffect for setting localDate whenever dateValue or type is updated
    if (datePicker) {
      if (type === "split" && split === "one") {
        setlocalDate(dateValue[type]?.data?.one);
      } else if (type === "split" && split === "two") {
        setlocalDate(dateValue[type]?.data?.two);
      } else if (type === "split" && split === "three") {
        setlocalDate(dateValue[type]?.data?.three);
      } else if (
        dateValue &&
        (type === "global_dashboard" ||
          type === "dashboard_section" ||
          type === "dashboard_widget" ||
          type === "template_global" ||
          type === "template_section" ||
          type === "template_widget" ||
          type === "advance_settings" ||
          type === "schedule_duration" ||
          type === "schedule_date_time" ||
          type === "widgetMaker" ||
          type === "preview" ||
          type === "share_modal" ||
          type === "orm_dashboard" ||
          type === "graph_page")
      ) {
        if (dateValue[type]?.data) {
          setlocalDate(dateValue[type]?.data);
        } else {
          setlocalDate(getCustomizedDate(6, "Days")?.date);
        }
      } else if (type === "CommandCenter") {
        if (dateValue[type]?.data) {
          setlocalDate(dateValue[type]?.data);
        } else {
          setlocalDate(getCustomizedDate(0, "Days")?.date);
        }
      }
    } else if (!datePicker) {
      //setlocalDate(null);
    }
  }, [dateValue, type, datePicker]);

  useEffect(() => {
    //useeffect for setting localTime whenever timeValue or type is updated

    if (type === "split" && split === "one" && timeValue) {
      setlocalTime(timeValue[type]?.data?.one);
    } else if (type === "split" && split === "two" && timeValue) {
      setlocalTime(timeValue[type]?.data?.two);
    } else if (type === "split" && split === "three" && timeValue) {
      setlocalTime(timeValue[type]?.data?.three);
    } else if (
      timeValue &&
      (type === "global_dashboard" ||
        type === "dashboard_section" ||
        type === "dashboard_widget" ||
        type === "template_global" ||
        type === "template_section" ||
        type === "template_widget" ||
        type === "advance_settings" ||
        type === "schedule_duration" ||
        type === "schedule_date_time" ||
        type === "widgetMaker" ||
        type === "preview" ||
        type === "share_modal" ||
        type === "orm_dashboard" ||
        type === "graph_page")
    ) {
      if (timeValue[type]?.data) {
        setlocalTime(timeValue[type]?.data);
      } else {
        setlocalTime(getCustomizedDate(6, "Days")?.time);
      }
    } else if (type === "CommandCenter") {
      if (timeValue[type]?.data) {
        setlocalTime(timeValue[type]?.data);
      } else {
        setlocalTime(getCustomizedDate(0, "Days")?.time);
      }
    }
  }, [timeValue]);

  //function is called when absolute date is selected

  const getDateValue = (value) => {
    let currentObj = dateValue[type]?.data; //set dateValue in currentObj
    let date = [
      moment(value[0]).format("DD MMM  YYYY"),
      moment(value[1]).format("DD MMM  YYYY"),
    ]; //format the dates and put it in array

    if (type === "split") {
      let finalObj;
      if (split === "one") {
        finalObj = {
          one: date,
          two: currentObj?.two,
          three: currentObj?.three,
        };
      } else if (split === "two") {
        finalObj = {
          one: currentObj?.one,
          two: date,
          three: currentObj?.three,
        };
      } else if (split === "three") {
        finalObj = {
          one: currentObj?.one,
          two: currentObj?.two,
          three: date,
        };
      }
      value[0] && value[1] && dispatch(setDateValue(dateValue, finalObj, type));
    } else {
      value[0] && value[1] && dispatch(setDateValue(dateValue, date, type));
    }

    dispatch(setRelativeCount(null));

    // Set keepAsRelative to false when absolute date is changed
    if (setKeepAsRelative && typeof setKeepAsRelative === "function") {
      setKeepAsRelative(false);
    }
  };

  const onTimeChange = (e, type1) => {
    let currentObj = timeValue[type]?.data; //set the timeValue in current obj
    let value = { ...localTime }; //set the localTime in value
    if (type1 === "start") {
      //for start(time) input type
      if (e.target.value === "") {
        value.startTime = "00:00";
      } else {
        value.startTime = e.target.value;
      }
    } else if (type1 === "end") {
      //for end(time) input type
      if (e.target.value === "") {
        value.endTime = "23:59";
      } else {
        value.endTime = e.target.value;
      }
    }

    let finalObj;

    if (type === "split") {
      if (split === "one") {
        finalObj = {
          one: value,
          two: currentObj?.two,
          three: currentObj?.three,
        };
      } else if (split === "two") {
        finalObj = {
          one: currentObj?.one,
          two: value,
          three: currentObj?.three,
        };
      } else if (split === "three") {
        finalObj = {
          one: currentObj?.one,
          two: currentObj?.two,
          three: value,
        };
      }
      value?.startTime &&
        value?.endTime &&
        dispatch(setTimeValue(timeValue, finalObj, type));
    } else {
      value?.startTime &&
        value?.endTime &&
        dispatch(setTimeValue(timeValue, value, type));
    }

    value?.startTime && value?.endTime && setlocalTime(value);

    // Set keepAsRelative to false when absolute time is changed
    if (setKeepAsRelative && typeof setKeepAsRelative === "function") {
      setKeepAsRelative(false);
    }
  };

  return (
    <div className={`p-15 otherDate `} style={{ minHeight: "31rem" }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {localDate?.length > 0 && (
          <StaticDateRangePicker
            displayStaticWrapperAs="desktop"
            className="staticDatePicker"
            value={
              panes[index]?.quick_filter === "CampaignID" ||
              screen?.quick_filter === "CampaignID"
                ? localDate
                  ? localDate
                  : campaignDate
                : localDate
            }
            onChange={(newValue) => getDateValue(newValue)}
            shouldDisableDate={(current) =>
              type === "global_dashboard" ||
              type === "advance_settings" ||
              type === "dashboard_section" ||
              type === "dashboard_widget" ||
              type === "template_global" ||
              type === "template_section" ||
              type === "template_widget" ||
              type === "graph_page" ||
              type === "schedule_duration" ||
              type === "schedule_date_time" ||
              type === "preview" ||
              type === "orm_dashboard" ||
              type === "share_modal" ||
              type === "widgetMaker" ||
              type === "CommandCenter"
                ? window?.location?.pathname?.split("/")?.[1] !==
                    "widgetMaker" &&
                  window?.location?.pathname?.split("/")?.[1] !==
                    "edit-widget" &&
                  ((panes[index]?.quick_filter === "CampaignID" &&
                    !authParams?.screen_id) ||
                    shareTemplateData?.quick_filter?.attribute ===
                      "CampaignID" ||
                    screen?.quick_filter?.toLowerCase() ===
                      "CampaignID"?.toLowerCase())
                  ? rangePickerDisabledDate(
                      current,
                      screen?.quick_filter?.toLowerCase() ===
                        "CampaignID"?.toLowerCase()
                        ? screen?.campaign_date?.from
                          ? screen?.campaign_date?.from
                          : null
                        : shareTemplateData?.start_date
                        ? shareTemplateData?.start_date
                        : panes[index]?.campaign_date?.from,
                      screen?.quick_filter === "CampaignID"
                        ? screen?.campaign_date?.to
                          ? screen?.campaign_date?.to
                          : null
                        : shareTemplateData?.end_date
                        ? shareTemplateData?.end_date
                        : panes[index]?.campaign_date?.to
                    )
                  : rangePickerDisabledDate(current, "01 Dec 2015", new Date())
                : type === "split" &&
                  rangePickerDisabledDate(
                    current,
                    graphDetailDuration
                      ? moment(graphDetailDuration?.from).format(
                          "YYYY/MM/DD HH:MM"
                        )
                      : moment(dateObj?.date[0]).format("YYYY/MM/DD HH:MM"),
                    graphDetailDuration
                      ? moment(graphDetailDuration?.to).format(
                          "YYYY/MM/DD HH:MM"
                        )
                      : moment(dateObj?.date[1]).format("YYYY/MM/DD HH:MM"),
                    null,
                    type
                  )
            }
          />
        )}
      </LocalizationProvider>

      <div
        className={`d-flex justify-content-between 
          
        `}
        // ${authParams?.theme_type == 1 ? "darkTheme" : ""}
      >
        <div className="form-group d-flex align-items-center m-0">
          <label
            className="mr-2 mb-0 text_regular font-weight500"
            style={{ minWidth: "7rem" }}
          >
            Start Time:
          </label>

          <input
            className="form-control font-size12 border-color border-radius-4 p-1"
            type="time"
            style={{ minWidth: "6rem" }}
            min="00:00"
            max="23:59"
            placeholder="Enter here"
            pattern="/^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/"
            onChange={(value) => onTimeChange(value, "start")}
            value={localTime?.startTime}
            required
          />
        </div>

        <div className="form-group d-flex align-items-center mb-0 ml-4">
          <label
            className="mr-2 mb-0 text_regular font-weight500"
            style={{ minWidth: "6.3rem" }}
          >
            End Time:
          </label>

          <input
            className="form-control font-size12 border-color border-radius-4 p-1"
            type="time"
            style={{ minWidth: "6rem" }}
            placeholder="hrs:mins"
            min="00:00"
            max="23:59"
            pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
            onChange={(value) => onTimeChange(value, "end")}
            value={localTime?.endTime}
            required
          />
        </div>
      </div>
      {timeFlag[0]?.data?.value && (
        <p className="error mt-1 mb-0">{timeFlag[0]?.data?.msg}</p>
      )}
      {timeFlag[1]?.data?.value && (
        <p className="error mt-1 mb-0">{timeFlag[1]?.data?.msg}</p>
      )}
    </div>
  );
};

export default React.memo(Absolute, isEqual);
